/**
 * RevenueCat Configuration
 *
 * This file contains all RevenueCat configuration including:
 * - App ID and API keys
 * - Product identifiers
 * - Package configuration with location-based pricing
 */

// Currency configuration for location-based pricing
export const CURRENCY_CONFIG = {
  EUR: {
    symbol: "€",
    countries: [
      "AT",
      "BE",
      "CY",
      "EE",
      "FI",
      "FR",
      "DE",
      "GR",
      "IE",
      "IT",
      "LV",
      "LT",
      "LU",
      "MT",
      "NL",
      "PT",
      "SK",
      "SI",
      "ES",
    ],
    weeklyPrice: 8.0,
    monthlyPrice: 15.0,
    annualPrice: 100.0,
  },
  GBP: {
    symbol: "£",
    countries: ["GB"],
    weeklyPrice: 8.0,
    monthlyPrice: 15.0,
    annualPrice: 100.0,
  },
  USD: {
    symbol: "$",
    countries: ["US", "CA"], // Default for other countries
    weeklyPrice: 8.0,
    monthlyPrice: 15.0,
    annualPrice: 100.0,
  },
} as const;

export type Currency = keyof typeof CURRENCY_CONFIG;

// Unified features across all tiers
const UNIFIED_FEATURES = [
  "Unlimited conversations",
  "70+ Languages",
  "Premium voice selection",
  "Access to past sessions",
];

export const REVENUECAT_CONFIG = {
  // App ID from RevenueCat dashboard
  appId: "app8ea0f9ad48",

  // Public API key for client-side SDK
  // Get this from: https://app.revenuecat.com/settings/api-keys
  publicApiKey: process.env.NEXT_PUBLIC_REVENUECAT_PUBLIC_KEY || "",

  // Product identifiers
  products: {
    weekly: "$rc_weekly",
    monthly: "$rc_monthly",
    annual: "Annual Subscription",
  },

  // Package configuration with unified features
  packages: {
    weekly: {
      identifier: "$rc_weekly",
      displayName: "Weekly",
      description: "",
      badge: "Max Flexibility",
      trialDays: 0,
      features: UNIFIED_FEATURES,
      mostPopular: false,
    },
    monthly: {
      identifier: "$rc_monthly",
      displayName: "Monthly",
      description: "",
      badge: "Most Popular",
      trialDays: 0,
      features: UNIFIED_FEATURES,
      mostPopular: true,
    },
    annual: {
      identifier: "Annual Subscription",
      displayName: "Annual",
      description: "",
      badge: "Best Value",
      trialDays: 0,
      features: UNIFIED_FEATURES,
      mostPopular: false,
    },
  },
} as const;

export type PackageType = keyof typeof REVENUECAT_CONFIG.packages;
